const CustodyAccountStatusEnum = Object.freeze({
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    PENDING: 'PENDING'
});

export default CustodyAccountStatusEnum;
